import { BiometricAuth, BiometryError, BiometryErrorType } from '@aparajita/capacitor-biometric-auth';
import { Capacitor } from '@capacitor/core';
import { Injectable, inject } from '@angular/core';
import { asyncScheduler } from 'rxjs';

import { OverlayService } from '@app/services/overlay.service';
import { ToastService } from '@app/services/toast.service';

@Injectable({
  providedIn: 'root',
})
export class BiometricAuthService {
  private overlay = inject(OverlayService);
  private toastSrv = inject(ToastService);

  private isChecking = false;

  async authenticate(): Promise<void> {
    if (this.isChecking || !Capacitor.isNativePlatform()) {
      return;
    }

    try {
      this.overlay.show();
      this.isChecking = true; // BiometricAuth.authenticate() method initiates a new event platform.resume, so we need to prevent multiple calls

      const result = await BiometricAuth.checkBiometry();
      if (result.isAvailable) {
        const isAuthenticated = await this.bioAuth();
        if (isAuthenticated) {
          this.overlay.hide();
        }
        asyncScheduler.schedule(() => (this.isChecking = false), 500);
      } else {
        console.log('Biometry Auth is not available', result);
        this.overlay.hide();
        this.isChecking = false;
      }
    } catch (error: unknown) {
      console.log('Check Biometry Auth Error', error);
      this.overlay.hide();
      this.isChecking = false;
    }
  }

  private async bioAuth(): Promise<boolean> {
    try {
      await BiometricAuth.authenticate({
        allowDeviceCredential: true,
        androidConfirmationRequired: false,
        cancelTitle: 'Cancel',
      });
      return true;
    } catch (err) {
      if (err instanceof BiometryError) {
        if (err.code === BiometryErrorType.userCancel) {
          console.log('Biometry Auth Canceled');
        } else {
          console.log('Biometry Auth Error', err.message);
          this.toastSrv.showToast(err.message);
          return this.bioAuth(); // call again until success
        }
      }
      return false;
    }
  }
}
